import { createSlice } from '@reduxjs/toolkit';

export const notification=createSlice({
    name:"notification",
    initialState: {
        popup:{
            notificationPopup:false
        },
        other:{
            notificationList:[],
            unreadMessageCount:0
        }
    },
    reducers:{
        // state for popup
        openNotificationPopup:(state) =>{
            state.popup.notificationPopup=true
        },
        closeNotificationPopup:(state) =>{
            state.popup.notificationPopup=false
        },

        // state for other
        addNotificationList:(state, action) =>{
            state.other.notificationList=action.payload
        },
        addUnreadMessageCount:(state, action) =>{
            state.other.unreadMessageCount=action.payload
        }
    }
})

export const {openNotificationPopup, closeNotificationPopup, addNotificationList, 
addUnreadMessageCount}=notification.actions

// popup state
export const getNotificationPopup=(state)=>state.notification.popup.notificationPopup

// other state
export const getNotificationList=(state)=>state.notification.other.notificationList
export const getUnreadMessageCount=(state)=>state.notification.other.unreadMessageCount

export default notification.reducer